module.exports = __webpack_public_path__ + "assets/assets/images/rootCanalFaq/all-canals-treated.55b38edf.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/rootCanalFaq/all-canals-treated.png
// module id = 299
// module chunks = 0